import { CapacityBracket } from '../types/capacity-brackets.types';

export function formatPrice(price: number, pricingUnit: string): string {
  const formatted = new Intl.NumberFormat('fr-FR').format(price) + ' FCFA';
  return pricingUnit === 'per_person' ? formatted + ' / pers.' : formatted;
}

export function getDurationLabel(durationType: string): string {
  switch (durationType) {
    case 'FORFAIT':
      return 'Forfait';
    case 'HALF_DAY':
      return 'Demi-journée';
    case 'FULL_DAY':
      return 'Journée complète';
    case 'MONTH':
      return 'Mois';
    default:
      return durationType;
  }
}

export function emptyBracket(order: number): CapacityBracket {
  return {
    label: '',
    minCapacity: 1,
    maxCapacity: 10,
    bracketType: 'duration',
    pricingUnit: 'per_group',
    roomName: '',
    prices: [
      { durationType: 'HALF_DAY', price: 100000 },
      { durationType: 'FULL_DAY', price: 150000 },
      { durationType: 'MONTH', price: 3000000 },
    ],
    order,
    isCustom: true,
  };
}
